<template>
    <div>
        <categories
                :title="title"
                :category-id="categoryId"
                :url_search="url_search"
                :product_type_id="product_type_id"
                :url-categories="'/pagination/store/categories-by-product-type-id/'
                + product_type_id
                + '/campaign-type/'
                + campaignType"
        ></categories>

        <div class="container">
            <div class="themes-thumbnails col-sm-12">
                <data-list-component :data-source="fetchUrl">
                    <template slot-scope="slotData">
                        <loader :show-loader="slotData.loading"></loader>
                        <div v-for="bundle in slotData.items" :key="bundle.id"
                             class=" col-sm-12 col-md-4 mt-10 data-list-component">
                            <card-horizontal :bundle="bundle"></card-horizontal>
                        </div>
                    </template>
                </data-list-component>
            </div>
        </div>
    </div>
</template>
<script>
    import Categories from './Categories.vue';
    import Card from './CardBundle.vue';
    import CardHorizontal from './CardHorizontal.vue';

    export default {
        name: 'list-bundles',

        props: {
            title: String,
            product_type_id: {
                type: Number,
                required: true,
            },
            categoryId: String,
            categories: Array,
            url_search: String,
            campaignType: String
        },

        components: {
            CardHorizontal,
            Categories,
            Card,
        },

        data: function () {
            return {
                fetchUrl: '',
                bundles: Array,
            };
        },
        computed: {
            bundlesChunks() {
                return _.chunk(_.values(this.bundles), 3);
            },
        },

        beforeCreate() {
            this.$root.$on('setBundles', (url) => {
                this.fetchUrl = url;
            });
        },
    };
</script>

<style scoped>
    .div-template {
        padding: 0;
    }

    .list-enter-active {
        display: none;
    }

    .list-enter-active, .list-leave-active {
        transition: all 0.5s;
    }

    .list-enter, .list-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    @media (min-width: 768px) {
        .data-list-component {
            height: 300px;
        }
    }

    .container, .themes-thumbnails {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/ListBundles.vue